module.exports = __webpack_public_path__ + "img/ide-turtle.b8577da4.svg";